import React from 'react';
import FlatButton from '@material-ui/core/Button';
import {white} from '../../themes/colors';
import './iconButton.scss';
import {withHover} from '../../compose/withHover';

const style = {
    borderRadius: '50%',
    color: white,
    padding: 0,
    minHeight: '45px',
    minWidth: '45px',
    height: '45px',
    lineHeight: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};
const IconButton = (props) => {

    const circleButtonProps = {...props};
    delete circleButtonProps.tooltip;
    delete circleButtonProps.onMouseEnter;
    delete circleButtonProps.onMouseOver;
    delete circleButtonProps.isHovering;
    delete circleButtonProps.containerClass;
    delete circleButtonProps.rippleColor;
    delete circleButtonProps.hoverColor;
    if (!circleButtonProps.style) {
        circleButtonProps.style = {};
    }
    circleButtonProps.style = {...style, ...circleButtonProps.style};
    circleButtonProps.className = `icon-button ${circleButtonProps.className || ''}`;
    return <div className={`relative ${props.containerClass || ''}`} id={props.id}>
        <FlatButton {...circleButtonProps} onMouseOver={props.onMouseOver} onMouseLeave={props.onMouseLeave} onClick={props.onClick} />
    </div>;
};

export default withHover(IconButton);
